import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {  setCredentials } from "../../redux/slices/authSlice";
import {  useUpdateUserMutation } from "../../redux/slices/usersApiSlice";
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FaCamera } from "react-icons/fa";
import {
  Edit3,
  Trash2,
  X,
  Plus,
  MapPin,
  Save,
  Loader2,
  Image as ImageIcon,
  Phone
} from 'lucide-react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

const Profile = () => {
  const [email, setEmail] = useState("");
  const [activeTab, setActiveTab] = useState('profile');
  const [name, setName] = useState("");
  const [card, setCard] = useState("");
  const [referralLink, setReferralLink] = useState("");
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [updateUser] = useUpdateUserMutation();
  const [referredUsers, setReferredUsers] = useState([]);
  const [showInfo, setShowInfo] = useState(false);
  const [solGrupSayisi, setSolGrupSayisi] = useState({ total: 0, paid: 0 });
  const [sagGrupSayisi, setSagGrupSayisi] = useState({ total: 0, paid: 0 });
  const [referrerInfo, setReferrerInfo] = useState(null);
  const [referrerInfoo, setReferrerInfoo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [referrerInf, setReferrerInf] = useState(null);
  const [referrerInfs, setReferrerInfs] = useState(null);
  const [showModa, setShowModa] = useState(false);
  const [referredUserss, setReferredUserss] = useState([]);
  const [referredUsersz, setReferredUsersz] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [logoutApiCall] = useLogoutMutation();
  const [paymentFilter, setPaymentFilter] = useState(null);
  const [paymentFilters, setPaymentFilters] = useState(null);
  const [stats, setStats] = useState(null);
  const [salaryData, setSalaryData] = useState(null);
  const [elanData, setElanData] = useState([]);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTert, setSearchTert] = useState("");
  const scrollRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const [editingAd, setEditingAd] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [newPhotos, setNewPhotos] = useState([]);
  const [deletingAdId, setDeletingAdId] = useState(null);
  const [deletingPhotoUrl, setDeletingPhotoUrl] = useState(null);

  const { userInfo } = useSelector((state) => state.auth);
  const MySwal = withReactContent(Swal);

  // Backend-dən gələn xətanı istifadəçiyə aydın şəkildə göstərir.
  const getErrorMessage = (error, fallback = "Əməliyyat zamanı xəta baş verdi.") => {
    const responseData = error?.response?.data;
    const backendMessage =
      (typeof responseData === "string" && responseData.trim()) ||
      responseData?.message ||
      responseData?.error ||
      responseData?.details;

    if (backendMessage) return backendMessage;

    if (!error?.response) {
      return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı yoxlayın və yenidən cəhd edin.";
    }

    switch (error.response.status) {
      case 400:
        return "Göndərilən məlumatlar düzgün deyil. Məlumatları yoxlayıb yenidən cəhd edin.";
      case 401:
        return "Sessiyanız başa çatıb. Zəhmət olmasa yenidən daxil olun.";
      case 403:
        return "Bu əməliyyatı yerinə yetirmək üçün icazəniz yoxdur.";
      case 404:
        return "Axtarılan məlumat tapılmadı.";
      case 413:
        return "Yüklədiyiniz fayl çox böyükdür.";
      case 415:
        return "Bu fayl formatı dəstəklənmir.";
      case 422:
        return "Daxil etdiyiniz məlumatlar düzgün deyil. Sahələri yoxlayın.";
      case 500:
        return "Serverdə daxili xəta baş verdi. Zəhmət olmasa bir qədər sonra yenidən cəhd edin.";
      default:
        return fallback;
    }
  };

  const showOperationError = (title, error, fallback) => {
    const message = getErrorMessage(error, fallback);
    return MySwal.fire({
      icon: "error",
      title,
      text: message,
      confirmButtonText: "Bağla",
      confirmButtonColor: "#2563eb",
      customClass: {
        popup: "rounded-2xl shadow-2xl",
        title: "text-xl font-bold",
      },
    });
  };

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/users/getuser/${userInfo._id}`, { withCredentials: true }
        );

        if (data.payment === false) {
          navigate("/");
        }
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          navigate("/");
        } else {
          console.error("İstifadəçinin ödəniş statusunu yoxlamaq mümkün olmadı:", error);
        }
      }
    };

    if (userInfo) {
      checkPaymentStatus();
    } else {
      navigate("/");
    }
  }, [userInfo, navigate]);

  // const handleLogout = async () => {
  //   try {
  //     await logoutApiCall().unwrap();
  //     dispatch(logout());
  //     navigate("/login");
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!card) {
      toast.error("Kart məlumatı tələb olunur!");
      return;
    }

    const formData = new FormData();
    formData.append("card", card);

    try {
      const res = await updateUser(formData).unwrap();
      dispatch(setCredentials({ ...res }));
      toast.success("Profil uğurla yeniləndi!");
      navigate("/");
    } catch (error) {
      toast.error(error?.data?.message || error.message || "Xəta baş verdi.");
    }
  };

  useEffect(() => {
    if (userInfo) {
      setName(userInfo.name);
      setEmail(userInfo.email);
      setPhoto(userInfo.photo);
      setReferralLink(userInfo.referralCode);
      setCard(userInfo.card || "");

      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/users/user/${userInfo.referralCode}`, { withCredentials: true })
        .then((res) => {
          setReferredUserss(res?.data?.users || []);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            setReferredUserss([]);
          } else {
            console.error("Referred users fetch error:", error);
          }
        });

      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/users/refCode/${userInfo.referralCode}`, { withCredentials: true })
        .then((res) => {
          setReferredUsersz(res?.data?.referredUsers || []);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            setReferredUsersz([]);
          } else {
            console.error("Referred users fetch error:", error);
          }
        });

      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/users/admin/${userInfo.referralCode}`, { withCredentials: true })
        .then(async (res) => {
          const users = res?.data?.users || [];
          setReferredUsers(users);

          const rightUser = users.find(
            (user) => String(user.side || "").trim().toLowerCase() === "right"
          );

          const leftUser = users.find(
            (user) => String(user.side || "").trim().toLowerCase() === "left"
          );

          const rightPromise = rightUser?.referralCode
            ? axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/api/users/user/${rightUser.referralCode}`,
              { withCredentials: true }
            )
            : Promise.resolve({ data: { users: [] } });

          const leftPromise = leftUser?.referralCode
            ? axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/api/users/user/${leftUser.referralCode}`,
              { withCredentials: true }
            )
            : Promise.resolve({ data: { users: [] } });

          const [rightRes, leftRes] = await Promise.all([
            rightPromise,
            leftPromise,
          ]);

          const rightGroup = rightRes?.data?.users || [];
          const leftGroup = leftRes?.data?.users || [];

          setSagGrupSayisi({
            total: rightGroup.length,
            paid: rightGroup.filter((u) => u.payment === true).length,
          });

          setSolGrupSayisi({
            total: leftGroup.length,
            paid: leftGroup.filter((u) => u.payment === true).length,
          });
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            setReferredUsers([]);
          } else {
            console.error("Referred users fetch error:", error);
          }
        });
    }
  }, [userInfo]);

const filteredUsers = referredUserss
  .filter((user) => user.isDeleted !== true)
  .filter((user) => {
    const search = (searchTerm || "").toLowerCase();

    const name = (user.name || "").toLowerCase();
    const referralCode = (user.referralCode || "").toLowerCase();

    return (
      name.includes(search) ||
      referralCode.includes(search)
    );
  })
  .filter((user) => {
    if (paymentFilters === null) return true;

    return paymentFilters
      ? user.payment === true
      : user.payment === false;
  });

  const filteredUserz = referredUsersz
    .filter((user) =>
      user.name.toLowerCase().includes(searchTert.toLowerCase()) ||
      user.referralCode.toLowerCase().includes(searchTert.toLowerCase())
    )
    .filter((user) => {
      if (paymentFilter === null) return true;
      return paymentFilter ? user.payment === true : user.payment === false;
    });

  const copyReferralLink = () => {
    navigator.clipboard.writeText(`${window.location.origin}/register?referral=${referralLink}`)
      .then(() => toast.success("Dəvət linkiniz kopyalandı!"))
      .catch(() => toast.error("Dəvət linki kopyalana bilmədi."));
  };

  const copyReferralLinke = () => {
    navigator.clipboard.writeText(`${referralLink}`)
      .then(() => toast.success("İstifadəçi kodunuz kopyalandı!"))
      .catch(() => toast.error("İstifadəçi kodunuz kopyalanmadı"));
  };

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    setPhoto(file);
    if (file) {
      setPhotoPreview(URL.createObjectURL(file));
      const formData = new FormData();
      formData.append('profileImage', file);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/users/profile/uploadImage`,
          formData,
          { withCredentials: true }
        );
        const cacheBustedUrl = res.data.imageUrl + '?v=' + Date.now();
        setPhoto(cacheBustedUrl);
        setPhotoPreview(null);
        dispatch(setCredentials({ ...userInfo, photo: cacheBustedUrl }));
        toast.success('Profil şəkli uğurla yükləndi!');
      } catch (error) {
        toast.error('Profil şəkli yüklənmədi!');
      }
    }
  };

  const handleNameClickl = async () => {
    try {
      const [res1, res2] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/get-link-owner/${userInfo.referralCode}`, { withCredentials: true }),
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/referredBykod/${userInfo.referralCode}`, { withCredentials: true })
      ]);
      setReferrerInf(res1.data);
      setReferrerInfs(res2.data);
      setShowModa(true);
    } catch (error) {
      setReferrerInf({ error: "Əsas dəvətçi tapılmadı." });
      setReferrerInfs({ error: "Əsas dəvətçi tapılmadı." });
      setShowModa(true);
    }
  };

  const handleNameClick = async (referralCode) => {
    try {
      const [res1, res2] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/get-link-owner/${referralCode}`, { withCredentials: true }),
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/referredBykod/${referralCode}`, { withCredentials: true })
      ]);
      setReferrerInfo(res1.data);
      setReferrerInfoo(res2.data);
      setShowModal(true);
    } catch (error) {
      setReferrerInfo({ error: "Əsas dəvətçi tapılmadı." });
      setReferrerInfoo({ error: "Əsas dəvətçi tapılmadı." });
      setShowModal(true);
    }
  };

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/users/getuser/${userInfo._id}`, { withCredentials: true }
        );

        if (data.payment === false) {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/kart`, { withCredentials: true });
          const kartlar = response.data.allKart || [];

          const kartHtml = kartlar.map((item) => {
            return `
              <div class="bg-gray-100 p-4 rounded-lg flex items-center justify-between cursor-pointer border border-gray-300 mb-2 copyCard" data-kart="${item.kart}">
                <span class="font-mono text-lg">${item.kart}</span>
                <button class="text-blue-600 font-semibold text-sm ml-4">Kopyala</button>
              </div>
            `;
          }).join('');

          MySwal.fire({
            title: `💳 Salam, ${data.name}!`,
            html: `
              <p class="text-lg mb-2">Qeydiyyatınızı tamamlamaq üçün zəhmət olmasa ödəniş edin.
		Ödəniş ayda cəmi 1 dəfə – 15 AZN təşkil edir.
		Ödənişdən sonra şəxsi kabinetiniz aktivləşir və qazancınız avtomatik hesablanmağa başlayır.
		Maaş hesablaması yalnız ödəniş edən üzvlər üçün açıqdır.
		Diqqət: Ödəniş geri qaytarılmır. Komandamıza xoş gəlmisiniz – uğura gedən yol buradan başlayır!</p>
              ${kartHtml}
              <p class="text-sm text-gray-500 mt-2">Qeyd: Ödəniş etdikdən sonra qəbzi WhatsApp-da administratora və ya çat-bota göndərin ✅</p>
            `,
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'Sonra',
            cancelButtonColor: '#F87171',
            background: '#f9fafb',
            customClass: {
              popup: 'rounded-2xl shadow-2xl border border-gray-200',
              title: 'text-2xl font-semibold text-gray-800',
            },
            didOpen: () => {
              const cards = document.querySelectorAll('.copyCard');
              cards.forEach((cardDiv) => {
                cardDiv.addEventListener('click', () => {
                  const kart = cardDiv.getAttribute('data-kart');
                  navigator.clipboard.writeText(kart.replace(/\s/g, ''));
                  Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Kart nömrəsi kopyalandı!',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                    background: '#ecfdf5',
                    color: '#065f46',
                  });
                });
              });
            },
          });
        }
      } catch (error) {
        console.error('Xəta:', error);
      }
    };

    if (userInfo?._id) {
      checkPaymentStatus();
    }
  }, [userInfo]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/users/referral-stats/${userInfo.referralCode}`, { withCredentials: true }
        );
        setStats(res.data);
        setError(null);
      } catch (error) {
        setError(error.response?.data?.message || "Məlumatları əldə etmək mümkün olmadı.");
      }
    };

    if (userInfo?.referralCode) fetchStats();
  }, [userInfo]);

  useEffect(() => {
    const fetchSalaryData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/users/salary/${userInfo.referralCode}`, { withCredentials: true }
        );
        setSalaryData(response.data);
        setError(null);
      } catch (error) {
        setError(error.response?.data?.message || "Maaş verisi alınarkən bir xəta baş verdi.");
      }
    };

    if (userInfo?.referralCode) fetchSalaryData();
  }, [userInfo]);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userInfo?._id) return;

      try {
        const { data: userData } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/getuser/${userInfo._id}`, { withCredentials: true });
        const currentMonth = new Date().getFullYear() + "-" + (new Date().getMonth() + 1);
        const shownMonth = localStorage.getItem("paymentShownMonth");

        if (userData.payment) {
          if (shownMonth !== currentMonth) {
            MySwal.fire({
              title: "Təbriklər!",
              html: `
                <p>Uğura xoş gəlmisiniz!<br />
                Artıq siz rəsmi şəkildə sistemə daxil oldunuz və bu, həyatınızda yeni bir başlanğıcdır!</p>
                <p><strong>Buradan sonrası sizdən asılıdır.</strong><br />
                15 AZN ilə başlanan bu yol – sizi yüzlərlə qazanan insan arasında görmək üçün atılmış ilk addımdır.</p>
                <p>📌 <strong>İndi nə etməli?</strong><br />
                1. WhatsApp qrupuna qoşul – dəstək və yönləndirmə üçün.<br />
                2. Gündəlik təlimləri izləməyə başla.<br />
                3. İlk qazancını elə bu gün qazan!</p>
                <p>🔗 <a href="https://chat.whatsapp.com/GpXwAPiRHLHFIMz4BE7s5e?s=cl&p=a&mlu=4&ilr=4" target="_blank" style="color: #1d72f3; font-weight: bold;">WhatsApp Qrupuna Qoşul</a></p>
              `,
              icon: "success",
              confirmButtonText: "Bağla"
            });
            localStorage.setItem("paymentShownMonth", currentMonth);
          }
        } else {
          localStorage.removeItem("paymentShownMonth");
        }
      } catch (error) {
        console.error("Ödəniş statusu yoxlanılarkən xəta baş verdi:", error);
      }
    };

    fetchUserData();
  }, [userInfo]);

  const fetchElanData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/pagination/id/user/${userInfo._id}`,
        { withCredentials: true }
      );

      setElanData(response.data.products || []);
    } catch (error) {
      const message = getErrorMessage(
        error,
        "Elanlar yüklənərkən gözlənilməz xəta baş verdi."
      );
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchElanData();
  }, [userInfo]);

  const handleDeleteSinglePhoto = async (id, photoUrl) => {
    const result = await MySwal.fire({
      icon: "warning",
      title: "Fotoşəkli silmək istəyirsiniz?",
      text: "Bu əməliyyat geri qaytarıla bilməz.",
      showCancelButton: true,
      confirmButtonText: "Bəli, sil",
      cancelButtonText: "Ləğv et",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      reverseButtons: true,
      customClass: { popup: "rounded-2xl shadow-2xl" },
    });

    if (!result.isConfirmed) return;

    try {
      setDeletingPhotoUrl(photoUrl);

      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/pagination/${id}/photo?url=${encodeURIComponent(photoUrl)}`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        setEditingAd((prev) => prev ? ({
          ...prev,
          photo: (prev.photo || []).filter((p) => p !== photoUrl),
        }) : prev);

        setElanData((prev) => prev.map((ad) =>
          ad._id === id
            ? { ...ad, photo: (ad.photo || []).filter((p) => p !== photoUrl) }
            : ad
        ));

        await MySwal.fire({
          icon: "success",
          title: "Fotoşəkil silindi",
          text: "Fotoşəkil elandan uğurla silindi.",
          confirmButtonText: "Bağla",
          confirmButtonColor: "#2563eb",
          timer: 1800,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Fotoşəkil silinərkən xəta:", error);
      await showOperationError(
        "Fotoşəkil silinmədi",
        error,
        "Fotoşəkili silmək mümkün olmadı."
      );
    } finally {
      setDeletingPhotoUrl(null);
    }
  };

  const handleDeleteAd = async (id) => {
    const result = await MySwal.fire({
      icon: "warning",
      title: "Elanı silmək istəyirsiniz?",
      text: "Elan və ona bağlı məlumatlar silinəcək. Bu əməliyyat geri qaytarıla bilməz.",
      showCancelButton: true,
      confirmButtonText: "Bəli, sil",
      cancelButtonText: "Ləğv et",
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#6b7280",
      reverseButtons: true,
      customClass: { popup: "rounded-2xl shadow-2xl" },
    });

    if (!result.isConfirmed) return;

    try {
      setDeletingAdId(id);
      setError(null);

      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/pagination/delete/${id}`,
        { withCredentials: true }
      );

      setElanData((prev) => prev.filter((ad) => ad._id !== id));

      await MySwal.fire({
        icon: "success",
        title: "Elan silindi",
        text: "Elanınız uğurla silindi.",
        confirmButtonText: "Bağla",
        confirmButtonColor: "#2563eb",
        timer: 1800,
        timerProgressBar: true,
      });
    } catch (error) {
      console.error("Elan silinərkən xəta:", error);
      await showOperationError(
        "Elan silinmədi",
        error,
        "Elanı silmək mümkün olmadı."
      );
    } finally {
      setDeletingAdId(null);
    }
  };

  const handleUpdateAd = async (e) => {
    e.preventDefault();
    if (!editingAd?._id) return;

    setUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('title', editingAd.title || '');
    formData.append('description', editingAd.description || '');
    formData.append('price', editingAd.price || 0);
    formData.append('category', editingAd.category || '');
    formData.append('condition', editingAd.condition || 'new');
    formData.append('brand', editingAd.brand || '');
    formData.append('model', editingAd.model || '');
    formData.append('phone', editingAd.phone || '');
    formData.append('location', editingAd.location || '');
    formData.append('distance', editingAd.distance || '');
    formData.append('delivery', editingAd.delivery || false);
    formData.append('negotiable', editingAd.negotiable || false);
    formData.append('warranty', editingAd.warranty || '');
    formData.append('stock', editingAd.stock || 1);
    formData.append('status', editingAd.status || 'active');

    if (newPhotos.length > 0) {
      newPhotos.forEach((file) => {
        formData.append('photo', file);
      });
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/pagination/update/id/${editingAd._id}`,
        formData,
        { withCredentials: true }
      );

      setEditingAd(null);
      setNewPhotos([]);
      await fetchElanData();

      await MySwal.fire({
        icon: "success",
        title: "Elan yeniləndi",
        text: "Dəyişikliklər uğurla yadda saxlanıldı.",
        confirmButtonText: "Bağla",
        confirmButtonColor: "#2563eb",
        timer: 1800,
        timerProgressBar: true,
      });
    } catch (error) {
      console.error("Elan yenilənərkən xəta:", error);
      await showOperationError(
        "Elan yenilənmədi",
        error,
        "Dəyişiklikləri yadda saxlamaq mümkün olmadı."
      );
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteNewPhoto = (idx) => {
    setNewPhotos((prev) => prev.filter((_, i) => i !== idx));
  };  

  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light"
  );
  const element = document.documentElement;

  useEffect(() => {
    if (theme === "dark") {
      element.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      element.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [theme]);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 font-sans antialiased text-gray-800 dark:text-gray-100 p-4 sm:p-8 transition-colors duration-200">
      <div className="max-w-7xl mx-auto space-y-8">

        {/* BAŞLIQ VƏ AKSİYONLAR */}
        {/* <header className="flex justify-between items-center py-4 border-b-2 border-gray-300 dark:border-gray-700">
          <button
            onClick={() => navigate("/")}
            className="text-lg text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 font-medium transition-colors"
          >
            &larr; Geri Qayıt
          </button>
          <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">
            İstifadəçi Paneli
          </h1>
          <button
            onClick={handleLogout}
            className="bg-red-600 text-white px-5 py-2 rounded-lg shadow-md hover:bg-red-700 transition-colors text-lg font-medium"
          >
            Çıxış
          </button>
        </header> */}

        {/* STATİSTİK KARTLARI */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-white dark:bg-gray-800 p-5 rounded-lg border-l-4 border-green-500 shadow-sm transition-colors">
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Maaş</p>
            <p className="text-2xl font-bold text-green-700 dark:text-green-400 mt-1">{salaryData?.salary || 0} ₼</p>
          </div>
          <div className="bg-white dark:bg-gray-800 p-5 rounded-lg border-l-4 border-blue-500 shadow-sm transition-colors">
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Mükafat</p>
            <p className="text-2xl font-bold text-blue-700 dark:text-blue-400 mt-1">{stats?.totalEarned || 0} ₼</p>
          </div>
          <div className="bg-white dark:bg-gray-800 p-5 rounded-lg border-l-4 border-purple-500 shadow-sm transition-colors">
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Rütbəsi</p>
            <p className="text-2xl font-bold text-purple-700 dark:text-purple-400 mt-1">{salaryData?.rank || "—"}</p>
          </div>
        </div>

        {/* ANA KART VƏ TABLAR */}
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 transition-colors">

          {/* TAB Naviqasiyası */}
          <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
            <nav className="-mb-px flex space-x-4 sm:space-x-8 overflow-x-auto" aria-label="Tabs">
              <a
                href="#"
                onClick={() => setActiveTab('profile')}
                className={`
                  ${activeTab === 'profile'
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400 font-semibold'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600 font-medium'
                  } 
                  whitespace-nowrap py-4 px-2 sm:px-4 text-lg border-b-2 transition-colors
                `}
              >
                Profil & Məlumatlar
              </a>

              <a
                href="#"
                onClick={() => setActiveTab('groups')}
                className={`
                  ${activeTab === 'groups'
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400 font-semibold'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600 font-medium'
                  } 
                  whitespace-nowrap py-4 px-2 sm:px-4 text-lg border-b-2 transition-colors
                `}
              >
                Sağ və sol qollar
              </a>

              <a
                href="#"
                onClick={() => setActiveTab('qrouplar')}
                className={`
                  ${activeTab === 'qrouplar'
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400 font-semibold'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600 font-medium'
                  } 
                  whitespace-nowrap py-4 px-2 sm:px-4 text-lg border-b-2 transition-colors
                `}
              >
                Qruplar cədvəli
              </a>

              <a
                href="#"
                onClick={() => setActiveTab('referrals')}
                className={`
                  ${activeTab === 'referrals'
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400 font-semibold'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600 font-medium'
                  } 
                  whitespace-nowrap py-4 px-2 sm:px-4 text-lg border-b-2 transition-colors
                `}
              >
                Şəxsi Dəvətlilər
              </a>

              <a
                href="#"
                onClick={() => setActiveTab('elanlar')}
                className={`
                  ${activeTab === 'elanlar'
                    ? 'border-blue-500 text-blue-600 dark:text-blue-400 font-semibold'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-600 font-medium'
                  } 
                  whitespace-nowrap py-4 px-2 sm:px-4 text-lg border-b-2 transition-colors
                `}
              >
                Elanlarım
              </a>

              <button
                onClick={() => navigate("/cedvel")}
                className="text-base font-medium text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 ml-auto whitespace-nowrap self-center pr-2"
              >
                Cədvələ keçid &rarr;
              </button>
            </nav>
          </div>

          {/* TAB 1: PROFİL VƏ FORMLAR */}
          {activeTab === 'profile' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

              {/* SOL: PROFİL VƏ ŞƏXSİ MƏLUMAT */}
              <div className="lg:col-span-1 space-y-6">
                <div className="text-center space-y-3 p-4 border rounded-lg bg-gray-50 dark:bg-gray-700/50 dark:border-gray-700">
                  <div className="relative w-32 h-32 mx-auto">
                    <img
                      src={photoPreview || photo}
                      alt="Profil"
                      className="w-full h-full object-cover rounded-full border-4 border-white dark:border-gray-800 ring-2 ring-blue-500 shadow"
                    />
                    <label className="absolute bottom-0 right-0 bg-blue-600 p-2 rounded-full cursor-pointer hover:bg-blue-700 transition-colors">
                      <FaCamera className="text-white h-4 w-4" />
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoChange}
                        className="hidden"
                      />
                    </label>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{name}</h2>
                  <p className="text-md text-gray-600 dark:text-gray-300">{email}</p>
                  {error && (
                    <p className="text-red-500 text-sm font-medium">{error}</p>
                  )}
                </div>

                {/* ŞƏXSİ MƏLUMATLAR AÇILIR/KAPANIR */}
                <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 bg-white dark:bg-gray-800">
                  <div className="flex justify-between items-center cursor-pointer" onClick={() => setShowInfo(!showInfo)}>
                    <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">Şəxsi Detallar</h3>
                    <span className="text-blue-500 dark:text-blue-400 font-bold text-xl">{showInfo ? "−" : "+"}</span>
                  </div>

                  {showInfo && (
                    <dl className="space-y-3 text-left p-2 border-t border-gray-200 dark:border-gray-700 mt-4 pt-4">
                      <div className="flex justify-between border-b border-gray-100 dark:border-gray-700/50 pb-1">
                        <dt className="text-sm font-medium text-gray-500 dark:text-gray-400">Ad Soyad:</dt>
                        <dd onClick={() => handleNameClickl(userInfo.referralCode)} className="text-sm font-semibold text-blue-600 dark:text-blue-400 cursor-pointer hover:underline">{userInfo.name}</dd>
                      </div>
                      <div className="flex justify-between border-b border-gray-100 dark:border-gray-700/50 pb-1">
                        <dt className="text-sm font-medium text-gray-500 dark:text-gray-400">Telefon:</dt>
                        <dd className="text-sm text-gray-900 dark:text-gray-200">{userInfo.phone}</dd>
                      </div>
                      <div className="flex justify-between border-b border-gray-100 dark:border-gray-700/50 pb-1">
                        <dt className="text-sm font-medium text-gray-500 dark:text-gray-400">FIN Kod:</dt>
                        <dd className="text-sm text-gray-900 dark:text-gray-200">{userInfo.finCode}</dd>
                      </div>
                      <div className="flex justify-between border-b border-gray-100 dark:border-gray-700/50 pb-1">
                        <dt className="text-sm font-medium text-gray-500 dark:text-gray-400">Ödəniş:</dt>
                        <dd className={`text-sm font-semibold ${userInfo.payment ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
                          {userInfo.payment ? "Ödənilib" : "Ödənilməyib"}
                        </dd>
                      </div>
                      <div className="flex justify-between">
                        <dt className="text-sm font-medium text-gray-500 dark:text-gray-400">Ata Adı:</dt>
                        <dd className="text-sm text-gray-900 dark:text-gray-200">{userInfo.faze}</dd>
                      </div>
                    </dl>
                  )}
                </div>
              </div>

              {/* SAĞ: FORM BLOKU */}
              <div className="lg:col-span-2 space-y-6 border border-gray-200 dark:border-gray-700 p-6 rounded-lg bg-gray-50 dark:bg-gray-700/50">
                <h2 className="text-xl font-bold text-gray-900 dark:text-white border-b border-gray-200 dark:border-gray-700 pb-3">Kart və Referans Məlumatları</h2>

                <form onSubmit={handleSubmit} className="space-y-5">

                  {/* Kart Nömrəsi */}
                  <div>
                    <label htmlFor="card-input" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Kart Nömrəsi
                    </label>
                    <input
                      id="card-input"
                      type="text"
                      value={card}
                      onChange={(e) => setCard(e.target.value)}
                      placeholder="0000 0000 0000 0000"
                      className="w-full border border-gray-300 dark:border-gray-600 rounded-md p-3 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                    />
                  </div>

                  {/* İstifadəçi Kodu VƏ Referans Linki */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* İstifadəçi Kodu */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        İstifadəçi kodunuz
                      </label>
                      <div className="flex border border-gray-300 dark:border-gray-600 rounded-md overflow-hidden">
                        <span className="flex-1 p-3 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 text-sm truncate">
                          {referralLink}
                        </span>
                        <button
                          type="button"
                          onClick={copyReferralLinke}
                          className="px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white transition-colors text-sm font-medium"
                        >
                          Kodu kopyala
                        </button>
                      </div>
                    </div>

                    {/* Referans Linki */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Dəvət linkiniz
                      </label>
                      <div className="flex border border-gray-300 dark:border-gray-600 rounded-md overflow-hidden">
                        <a
                          href={`${window.location.origin}/register?referral=${referralLink}`}
                          target="_blank"
                          rel="noreferrer"
                          className="flex-1 p-3 bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 text-sm truncate cursor-pointer hover:underline"
                        >
                          {`${window.location.origin}/register?referral=${referralLink}`}
                        </a>
                        <button
                          type="button"
                          onClick={copyReferralLink}
                          className="px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white transition-colors text-sm font-medium"
                        >
                          Linki kopyala
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Güncelle Butonu */}
                  <div className="flex justify-end pt-4">
                    <button
                      type="submit"
                      className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-lg font-medium shadow"
                    >
                      Məlumatları yenilə
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* TAB 2: TABLOLAR */}
          <div className="space-y-8 mt-12 pt-6 border-t border-gray-200 dark:border-gray-700">

            {/* SAĞ SOL QOLLAR TABLOSU */}
            {activeTab === 'groups' && (
              <div className="border border-gray-300 dark:border-gray-700 rounded-lg overflow-hidden">
                <header className="flex justify-between items-center p-4 border-b border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                  <h2 className="text-xl font-bold text-gray-800 dark:text-white">Sağ və sol qollar cədvəli</h2>
                </header>
                {referredUsers.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                      <thead className="bg-gray-50 dark:bg-gray-900">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Şəkil</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ad Soyad</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Kod</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Email</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Qol</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ödəniş</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Qrup sayı</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Tarix</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700">
                        {referredUsers.map((user) => (
                          <tr key={user._id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                              {user.photo ? (
                                <img
                                  src={user.photo}
                                  alt={user.name || "Profil"}
                                  className="w-10 h-10 rounded-full object-cover border border-gray-200 dark:border-gray-600"
                                />
                              ) : (
                                <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400">
                                  —
                                </div>
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600 dark:text-blue-400 cursor-pointer hover:underline" onClick={() => handleNameClick(user.referralCode)}>
                              {user.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">{user.referralCode}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 truncate">{user.email}</td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {String(user.side || "").trim().toLowerCase() === "right" ? (
                                <span className="px-3 py-1 inline-flex text-xs font-bold rounded-full bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300">
                                  Sağ qol
                                </span>
                              ) : String(user.side || "").trim().toLowerCase() === "left" ? (
                                <span className="px-3 py-1 inline-flex text-xs font-bold rounded-full bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300">
                                  Sol qol
                                </span>
                              ) : (
                                <span className="px-3 py-1 inline-flex text-xs font-bold rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400">
                                  Naməlum
                                </span>
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${user.payment ? 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300' : 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300'}`}>
                                {user.payment ? 'Ödənilib' : 'Ödənilməyib'}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                              {String(user.side || "").trim().toLowerCase() === "right"
                                ? `${sagGrupSayisi.total} (${sagGrupSayisi.paid} ödənişli)`
                                : String(user.side || "").trim().toLowerCase() === "left"
                                  ? `${solGrupSayisi.total} (${solGrupSayisi.paid} ödənişli)`
                                  : "-"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                              {new Date(user.createdAt).toLocaleDateString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="p-6 text-gray-600 dark:text-gray-400">Qol yoxdur.</p>
                )}
              </div>
            )}

            {/* QRUPLAR TABLOSU */}
            {activeTab === 'qrouplar' && (
              <div className="border border-gray-300 dark:border-gray-700 rounded-lg overflow-hidden">
                <h2 className="text-xl font-bold text-gray-800 dark:text-white p-4 border-b border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">Bütün Qruplar</h2>

                <div className="p-4 flex flex-col sm:flex-row gap-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
                  <input
                    type="text"
                    placeholder="Ad / Kod ilə axtarış"
                    className="flex-1 p-3 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-yellow-500 focus:border-yellow-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-400"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <select
                    value={paymentFilters === null ? "" : paymentFilters ? "paid" : "unpaid"}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "paid") setPaymentFilters(true);
                      else if (val === "unpaid") setPaymentFilters(false);
                      else setPaymentFilters(null);
                    }}
                    className="p-3 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-yellow-500 focus:border-yellow-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  >
                    <option value="">Bütün Ödənişlər</option>
                    <option value="paid">Ödəniş Edənlər</option>
                    <option value="unpaid">Ödəniş Etməyənlər</option>
                  </select>
                </div>

                {filteredUsers.length > 0 ? (
                  <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                      <thead className="sticky top-0 bg-gray-50 dark:bg-gray-900">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">#</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Şəkil</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ad Soyad</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Kod</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Email</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ödəniş</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Tarix</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700">
                        {filteredUsers.map((user, index) => (
                          <tr key={user._id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-700 dark:text-gray-300">{index + 1}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                              {user.photo ? (
                                <img
                                  src={user.photo}
                                  alt={user.name || "Profil şəkli"}
                                  className="w-10 h-10 rounded-full object-cover border border-gray-200 dark:border-gray-600"
                                />
                              ) : (
                                <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400">
                                  —
                                </div>
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600 dark:text-blue-400 cursor-pointer hover:underline" onClick={() => handleNameClick(user.referralCode)}>
                              {user.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">{user.referralCode}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 truncate">{user.email}</td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${user.payment ? 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300' : 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300'}`}>
                                {user.payment ? 'Ödənilib' : 'Ödənilməyib'}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                              {new Date(user.createdAt).toLocaleDateString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="p-6 text-gray-600 dark:text-gray-400">Axtarışa uyğun qrup üzvü tapılmadı.</p>
                )}
              </div>
            )}

            {/* ŞƏXSİ DƏVƏTLİLƏR TABLOSU */}
            {activeTab === 'referrals' && (
              <div className="border border-gray-300 dark:border-gray-700 rounded-lg overflow-hidden">
                <h2 className="text-xl font-bold text-gray-800 dark:text-white p-4 border-b border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">Şəxsi Dəvətlilər</h2>

                <div className="p-4 flex flex-col sm:flex-row gap-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
                  <input
                    type="text"
                    placeholder="Ad / Kod ilə axtarış"
                    className="flex-1 p-3 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-yellow-500 focus:border-yellow-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-400"
                    value={searchTert}
                    onChange={(e) => setSearchTert(e.target.value)}
                  />
                  <select
                    value={paymentFilter === null ? "" : paymentFilter ? "paid" : "unpaid"}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (val === "paid") setPaymentFilter(true);
                      else if (val === "unpaid") setPaymentFilter(false);
                      else setPaymentFilter(null);
                    }}
                    className="p-3 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-yellow-500 focus:border-yellow-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  >
                    <option value="">Bütün Ödənişlər</option>
                    <option value="paid">Ödəniş Edənlər</option>
                    <option value="unpaid">Ödəniş Etməyənlər</option>
                  </select>
                </div>

                {filteredUserz.length > 0 ? (
                  <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                      <thead className="sticky top-0 bg-gray-50 dark:bg-gray-900">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">#</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Şəkil</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ad Soyad</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Kod</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Email</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ödəniş</th>
                          <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Tarix</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700">
                        {filteredUserz.map((user, index) => (
                          <tr key={user._id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-700 dark:text-gray-300">{index + 1}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                              {user.photo ? (
                                <img
                                  src={user.photo}
                                  alt={user.name || "Profil şəkli"}
                                  className="w-10 h-10 rounded-full object-cover border border-gray-200 dark:border-gray-600"
                                />
                              ) : (
                                <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400">
                                  —
                                </div>
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600 dark:text-blue-400 cursor-pointer hover:underline" onClick={() => handleNameClick(user.referralCode)}>
                              {user.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">{user.referralCode}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300 truncate">{user.email}</td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${user.payment ? 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300' : 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300'}`}>
                                {user.payment ? 'Ödənilib' : 'Ödənilməyib'}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                              {new Date(user.createdAt).toLocaleDateString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="p-6 text-gray-600 dark:text-gray-400">Axtarışa uyğun şəxsi dəvətli tapılmadı.</p>
                )}
              </div>
            )}

            {/* ELANLARIM TABLOSU */}
            {activeTab === 'elanlar' && (
              <div className="bg-gray-50 dark:bg-gray-900 p-4 md:p-8 rounded-lg">
                <div className="max-w-7xl mx-auto">
                  <header className="mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                      <div className="flex items-center gap-3">
                        <div className="w-11 h-11 rounded-2xl bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                          <ImageIcon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                        </div>
                        <div>
                          <h1 className="text-3xl font-bold text-gray-800 dark:text-white">Elanlarım</h1>
                          <p className="text-gray-600 dark:text-gray-400">Elanlarınızı idarə edin, yeniləyin və silin.</p>
                        </div>
                      </div>
                    </div>
                  </header>

                  {loading && (
                    <div className="mb-6 flex items-center gap-4 rounded-2xl border border-blue-200 dark:border-blue-900/50 bg-blue-50 dark:bg-blue-900/20 p-4 shadow-sm">
                      <div className="shrink-0 rounded-xl bg-blue-100 dark:bg-blue-900/40 p-2.5">
                        <Loader2 className="w-5 h-5 animate-spin text-blue-600 dark:text-blue-400" />
                      </div>
                      <div>
                        <p className="font-semibold text-blue-900 dark:text-blue-200">Elanlar yüklənir...</p>
                        <p className="text-sm text-blue-700/80 dark:text-blue-300/80">Məlumatlar serverdən alınır. Zəhmət olmasa gözləyin.</p>
                      </div>
                    </div>
                  )}

                  {error && (
                    <div className="mb-6 flex items-start gap-3 rounded-2xl border border-red-200 dark:border-red-900/50 bg-red-50 dark:bg-red-900/20 p-4 shadow-sm">
                      <div className="mt-0.5 shrink-0 w-9 h-9 rounded-xl bg-red-100 dark:bg-red-900/40 flex items-center justify-center text-red-600 dark:text-red-400 font-bold">!</div>
                      <div className="min-w-0">
                        <p className="font-semibold text-red-800 dark:text-red-200">Məlumatları yükləmək mümkün olmadı</p>
                        <p className="text-sm text-red-700 dark:text-red-300 mt-1 break-words">{error}</p>
                        <button
                          type="button"
                          onClick={fetchElanData}
                          disabled={loading}
                          className="mt-3 inline-flex items-center gap-2 rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50 transition-colors"
                        >
                          Yenidən cəhd et
                        </button>
                      </div>
                    </div>
                  )}

                  {elanData.length === 0 && !loading ? (
                    <div className="text-center py-20 bg-white dark:bg-gray-800 rounded-3xl shadow-sm">
                      <ImageIcon className="w-16 h-16 mx-auto text-gray-300 dark:text-gray-600 mb-4" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Hələ heç bir elanınız yoxdur</h3>
                      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Əlavə etdiyiniz elanlar burada görünəcək.</p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {elanData.map((ad) => (
                        <div key={ad._id} className="bg-white dark:bg-gray-800 rounded-3xl overflow-hidden shadow-md hover:shadow-xl transition-shadow border border-gray-100 dark:border-gray-700 flex flex-col">

                          {/* Photo Carousel Container */}
                          <div className="relative group overflow-hidden bg-gray-100 dark:bg-zinc-900">
                            <div className="h-64 sm:h-72 w-full">
                              {ad.photo && Array.isArray(ad.photo) && ad.photo.length > 0 ? (
                                <Swiper
                                  modules={[Pagination, Navigation]}
                                  pagination={{ clickable: true, dynamicBullets: true }}
                                  navigation={true}
                                  className="h-full w-full mySwiper"
                                >
                                  {ad.photo.map((photo, index) => (
                                    <SwiperSlide key={index}>
                                      <div className="relative w-full h-full">
                                        <img
                                          src={photo}
                                          alt={`${ad.title || "Elan"} — şəkil ${index + 1}`}
                                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                          onError={(e) => {
                                            e.target.src = 'https://via.placeholder.com/400x300?text=Şəkil+Yüklənmədi';
                                          }}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" />
                                      </div>
                                    </SwiperSlide>
                                  ))}
                                </Swiper>
                              ) : (
                                <div className="w-full h-full flex flex-col items-center justify-center text-gray-400 gap-2">
                                  <ImageIcon size={48} strokeWidth={1} />
                                  <span className="text-sm font-medium">Şəkil tapılmadı</span>
                                </div>
                              )}
                            </div>

                            {/* Status Badges */}
                            <div className="absolute top-3 left-3 z-10 flex gap-2">
                              <span className={`px-2.5 py-1 rounded-lg text-xs font-bold text-white uppercase backdrop-blur-md ${ad.status === 'active' ? 'bg-green-500/80' : ad.status === 'sold' ? 'bg-red-500/80' : 'bg-gray-500/80'
                                }`}>
                                {ad.status === 'active' ? 'Aktiv' : ad.status === 'sold' ? 'Satıldı' : 'Gizli'}
                              </span>
                              {ad.condition && (
                                <span className="px-2.5 py-1 rounded-lg text-xs font-bold text-white bg-black/50 backdrop-blur-md">
                                  {ad.condition === 'new' ? 'Yeni' : 'İşlənmiş'}
                                </span>
                              )}
                            </div>

                            {/* Top Action Buttons */}
                            <div className="absolute top-3 right-3 z-10 flex gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300">
                              <button
                                onClick={() => setEditingAd(ad)}
                                className="p-2.5 bg-white/90 dark:bg-gray-800/90 text-blue-600 dark:text-blue-400 rounded-xl shadow-xl backdrop-blur-sm hover:bg-blue-600 hover:text-white transition-all"
                                title="Elanı redaktə et"
                              >
                                <Edit3 size={18} />
                              </button>
                              <button
                                onClick={() => handleDeleteAd(ad._id)}
                                className="p-2.5 bg-white/90 dark:bg-gray-800/90 text-red-600 dark:text-red-400 rounded-xl shadow-xl backdrop-blur-sm hover:bg-red-600 hover:text-white transition-all"
                                title="Elanı sil"
                              >
                                <Trash2 size={18} />
                              </button>
                            </div>
                          </div>

                          {/* Card Details Body */}
                          <div className="p-5 flex-1 flex flex-col justify-between">
                            <div>
                              <div className="flex justify-between items-start gap-2">
                                <h3 className="text-lg font-bold text-gray-800 dark:text-white truncate">{ad.title}</h3>
                                <p className="text-blue-600 dark:text-blue-400 font-extrabold text-xl whitespace-nowrap">{ad.price} AZN</p>
                              </div>

                              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 line-clamp-2">{ad.description}</p>

                              {/* Badges / Details Grid */}
                              <div className="grid grid-cols-2 gap-2 mt-4 text-xs">
                                {ad.category && (
                                  <div className="bg-gray-100 dark:bg-gray-700/50 p-2 rounded-lg text-gray-600 dark:text-gray-300">
                                    <span className="font-semibold block text-[10px] text-gray-400">Kateqoriya</span>
                                    {ad.category}
                                  </div>
                                )}
                                {(ad.brand || ad.model) && (
                                  <div className="bg-gray-100 dark:bg-gray-700/50 p-2 rounded-lg text-gray-600 dark:text-gray-300">
                                    <span className="font-semibold block text-[10px] text-gray-400">Marka / Model</span>
                                    {ad.brand} {ad.model}
                                  </div>
                                )}
                                {ad.warranty && (
                                  <div className="bg-gray-100 dark:bg-gray-700/50 p-2 rounded-lg text-gray-600 dark:text-gray-300">
                                    <span className="font-semibold block text-[10px] text-gray-400">Zəmanət</span>
                                    {ad.warranty}
                                  </div>
                                )}
                                <div className="bg-gray-100 dark:bg-gray-700/50 p-2 rounded-lg text-gray-600 dark:text-gray-300">
                                  <span className="font-semibold block text-[10px] text-gray-400">Stok</span>
                                  {ad.stock ?? 1} ədəd
                                </div>
                              </div>

                              {/* Options List */}
                              <div className="flex flex-wrap gap-2 mt-3 text-[11px]">
                                {ad.negotiable && <span className="bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 px-2 py-0.5 rounded">Razılaşma var</span>}
                                {ad.delivery && <span className="bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 px-2 py-0.5 rounded">Çatdırılma var</span>}
                              </div>
                            </div>

                            {/* Footer Info */}
                            <div className="border-t border-gray-100 dark:border-gray-700 pt-3 mt-4">
                              <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
                                <span className="flex items-center gap-1">
                                  <MapPin size={12} /> {ad.location || 'Ünvan daxil edilməyib'} {ad.distance ? `(${ad.distance} km)` : ''}
                                </span>
                                {ad.phone && (
                                  <span className="flex items-center gap-1">
                                    <Phone size={12} /> {ad.phone}
                                  </span>
                                )}
                              </div>

                              {/* Actions */}
                              <div className="flex gap-2 mt-4">
                                <button
                                  onClick={() => setEditingAd(ad)}
                                  className="flex-1 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold transition-colors flex items-center justify-center gap-2 text-xs"
                                >
                                  <Edit3 size={14} /> Redaktə Et
                                </button>
                                <button
                                  onClick={() => handleDeleteAd(ad._id)}
                                  className="py-2.5 px-3 bg-red-100 hover:bg-red-200 dark:bg-red-900/30 dark:hover:bg-red-900/50 text-red-600 dark:text-red-400 rounded-xl transition-colors"
                                  title="Sil"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* EDIT MODAL */}
                {editingAd && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
                    <div className="bg-white dark:bg-gray-800 w-full max-w-4xl max-h-[90vh] rounded-[2rem] overflow-hidden flex flex-col shadow-2xl border border-gray-200 dark:border-gray-700">
                      {/* Modal Header */}
                      <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Elanı redaktə et</h2>
                        <button onClick={() => { setEditingAd(null); setNewPhotos([]); }} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"><X className="text-gray-700 dark:text-white" /></button>
                      </div>

                      <form onSubmit={handleUpdateAd} className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-6 bg-white dark:bg-gray-800">

                        {/* Fotoşəkillərin idarə edilməsi */}
                        <div className="space-y-4">
                          <div className="flex items-center justify-between">
                            <label className="text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                              Fotoları idarə et
                            </label>
                            <span className="text-xs text-gray-400">
                              {editingAd.photo?.length || 0} mövcud / {newPhotos.length} yeni
                            </span>
                          </div>

                          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                            {editingAd.photo?.map((url, idx) => (
                              <div key={`old-${idx}`} className="relative aspect-square rounded-2xl overflow-hidden group border-2 border-transparent hover:border-blue-500 transition-all shadow-sm">
                                <img src={url} className="w-full h-full object-cover" alt="Elan" />
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteSinglePhoto(editingAd._id, url)}
                                    className="p-2 bg-red-600 text-white rounded-full hover:scale-110 transition-transform shadow-lg"
                                    title="Fotoşəkli sil"
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                </div>
                                <span className="absolute bottom-1 left-1 bg-black/60 text-white text-[10px] px-1.5 rounded">Mövcud</span>
                              </div>
                            ))}

                            {newPhotos.map((file, idx) => (
                              <div key={`new-${idx}`} className="relative aspect-square rounded-2xl overflow-hidden group border-2 border-green-500 transition-all shadow-md">
                                <img src={URL.createObjectURL(file)} alt="Yeni" className="w-full h-full object-cover" />
                                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteNewPhoto(idx)}
                                    className="p-2 bg-red-600 text-white rounded-full hover:scale-110 transition-transform shadow-lg"
                                  >
                                    <X size={16} />
                                  </button>
                                </div>
                                <span className="absolute bottom-1 left-1 bg-green-600 text-white text-[10px] px-1.5 rounded">Yeni</span>
                              </div>
                            ))}

                            <label className="aspect-square flex flex-col items-center justify-center border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-2xl cursor-pointer hover:bg-blue-50 dark:hover:bg-gray-700/50 transition-colors group">
                              <div className="bg-blue-100 dark:bg-gray-600 p-2 rounded-full group-hover:scale-110 transition-transform">
                                <Plus size={24} className="text-blue-600 dark:text-blue-400" />
                              </div>
                              <span className="text-[10px] font-bold text-gray-500 dark:text-gray-400 mt-2">Əlavə et</span>
                              <input
                                type="file"
                                multiple
                                className="hidden"
                                onChange={(e) => setNewPhotos([...newPhotos, ...Array.from(e.target.files)])}
                                accept="image/*"
                              />
                            </label>
                          </div>
                        </div>

                        {/* Form Input Fields */}
                        <div className="space-y-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                            {/* Title */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Elanın başlığı</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.title || ''}
                                onChange={e => setEditingAd({ ...editingAd, title: e.target.value })}
                              />
                            </div>

                            {/* Category */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Kateqoriya</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.category || ''}
                                onChange={e => setEditingAd({ ...editingAd, category: e.target.value })}
                              />
                            </div>

                            {/* Price */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Qiymət (AZN)</label>
                              <input
                                type="number"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.price || ''}
                                onChange={e => setEditingAd({ ...editingAd, price: e.target.value })}
                              />
                            </div>

                            {/* Status */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Status</label>
                              <select
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.status || 'active'}
                                onChange={e => setEditingAd({ ...editingAd, status: e.target.value })}
                              >
                                <option value="active">Aktiv</option>
                                <option value="sold">Satıldı</option>
                                <option value="hidden">Gizli</option>
                              </select>
                            </div>

                            {/* Condition */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Vəziyyəti</label>
                              <select
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.condition || 'new'}
                                onChange={e => setEditingAd({ ...editingAd, condition: e.target.value })}
                              >
                                <option value="new">Yeni</option>
                                <option value="used">İşlənmiş</option>
                              </select>
                            </div>

                            {/* Brand */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Marka</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.brand || ''}
                                onChange={e => setEditingAd({ ...editingAd, brand: e.target.value })}
                              />
                            </div>

                            {/* Model */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Model</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.model || ''}
                                onChange={e => setEditingAd({ ...editingAd, model: e.target.value })}
                              />
                            </div>

                            {/* Stock */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Stok miqdarı</label>
                              <input
                                type="number"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.stock || 1}
                                onChange={e => setEditingAd({ ...editingAd, stock: e.target.value })}
                              />
                            </div>

                            {/* Location */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Ünvan / yerləşmə yeri</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.location || ''}
                                onChange={e => setEditingAd({ ...editingAd, location: e.target.value })}
                              />
                            </div>

                            {/* Distance */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Məsafə (km)</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.distance || ''}
                                onChange={e => setEditingAd({ ...editingAd, distance: e.target.value })}
                              />
                            </div>

                            {/* Phone */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Əlaqə Nömrəsi</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.phone || ''}
                                onChange={e => setEditingAd({ ...editingAd, phone: e.target.value })}
                              />
                            </div>

                            {/* Warranty */}
                            <div className="space-y-1">
                              <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Zəmanət</label>
                              <input
                                type="text"
                                className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600"
                                value={editingAd.warranty || ''}
                                onChange={e => setEditingAd({ ...editingAd, warranty: e.target.value })}
                              />
                            </div>

                          </div>

                          {/* Description */}
                          <div className="space-y-1">
                            <label className="text-xs font-semibold text-gray-500 dark:text-gray-400 ml-1">Elanın açıqlaması</label>
                            <textarea
                              rows="4"
                              className="w-full p-4 bg-gray-50 dark:bg-gray-700 rounded-2xl text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 transition-all border border-gray-200 dark:border-gray-600 resize-none"
                              value={editingAd.description || ''}
                              onChange={e => setEditingAd({ ...editingAd, description: e.target.value })}
                            />
                          </div>

                          {/* Checkboxes: Negotiable & Delivery */}
                          <div className="flex gap-6 pt-2">
                            <label className="flex items-center gap-2 cursor-pointer text-gray-900 dark:text-white text-sm font-semibold">
                              <input
                                type="checkbox"
                                className="w-5 h-5 rounded text-blue-600 focus:ring-blue-500"
                                checked={editingAd.negotiable || false}
                                onChange={e => setEditingAd({ ...editingAd, negotiable: e.target.checked })}
                              />
                              Qiymət razılaşma yolu ilə
                            </label>

                            <label className="flex items-center gap-2 cursor-pointer text-gray-900 dark:text-white text-sm font-semibold">
                              <input
                                type="checkbox"
                                className="w-5 h-5 rounded text-blue-600 focus:ring-blue-500"
                                checked={editingAd.delivery || false}
                                onChange={e => setEditingAd({ ...editingAd, delivery: e.target.checked })}
                              />
                              Çatdırılma var
                            </label>
                          </div>

                        </div>

                        {/* Action Buttons */}
                        <div className="flex gap-4 sticky bottom-0 bg-white dark:bg-gray-800 py-4 border-t border-gray-200 dark:border-gray-700 z-10">
                          <button
                            type="submit"
                            disabled={uploading}
                            className="flex-[2] py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl font-bold flex items-center justify-center gap-2 shadow-lg disabled:opacity-50 transition-all"
                          >
                            {uploading ? <Loader2 className="animate-spin" /> : <Save size={20} />}
                            Dəyişiklikləri yadda saxla
                          </button>
                          <button
                            type="button"
                            onClick={() => setEditingAd(null)}
                            className="flex-1 py-4 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-white rounded-2xl font-bold hover:bg-gray-200 dark:hover:bg-gray-600 transition-all"
                          >
                            Ləğv et
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* MODALLAR */}

      {/* "Şəxsi Məlumatlar" Ad Tıklama Modalı */}
      {showModa && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-2xl relative w-full max-w-sm border border-gray-300 dark:border-gray-700 transition-colors">
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
              onClick={() => setShowModa(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            </button>

            <h3 className="text-xl font-bold text-center text-blue-600 dark:text-blue-400 mb-6 border-b border-gray-200 dark:border-gray-700 pb-3">Dəvət Məlumatları</h3>

            <div className="space-y-6">
              {/* Dəvət Edən Şəxs */}
              <div className="text-center p-4 border border-blue-100 dark:border-blue-900/30 rounded-md bg-blue-50 dark:bg-blue-900/20">
                <h4 className="text-lg font-semibold text-blue-800 dark:text-blue-300 mb-3">Dəvət edən şəxs</h4>
                {referrerInf?.error ? (
                  <p className="text-red-500 dark:text-red-400">{referrerInf.error}</p>
                ) : (
                  <div className="space-y-2">
                    {referrerInf?.referrerPhoto && (
                      <img src={referrerInf.referrerPhoto} alt="Dəvət edən şəxsin şəkli" className="w-16 h-16 object-cover mx-auto rounded-full ring-2 ring-white dark:ring-gray-700" />
                    )}
                    <p className="text-base font-medium text-gray-700 dark:text-gray-200">{referrerInf?.referrerName}</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">{referrerInf?.referrerEmail}</p>
                  </div>
                )}
              </div>

              {/* Lider */}
              <div className="text-center p-4 border border-purple-100 dark:border-purple-900/30 rounded-md bg-purple-50 dark:bg-purple-900/20">
                <h4 className="text-lg font-semibold text-purple-800 dark:text-purple-300 mb-3">Lider</h4>
                {referrerInfs?.error ? (
                  <p className="text-red-500 dark:text-red-400">{referrerInfs.error}</p>
                ) : (
                  <div className="space-y-2">
                    {referrerInfs?.referrerPhoto && (
                      <img src={referrerInfs.referrerPhoto} alt="Liderin şəkli" className="w-16 h-16 object-cover mx-auto rounded-full ring-2 ring-white dark:ring-gray-700" />
                    )}
                    <p className="text-base font-medium text-gray-700 dark:text-gray-200">{referrerInfs?.referrerName}</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">{referrerInfs?.referrerEmail}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tablo Ad Tıklama Modalı */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-2xl relative w-full max-w-sm border border-gray-300 dark:border-gray-700 transition-colors">
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
              onClick={() => setShowModal(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            </button>

            <h3 className="text-xl font-bold text-center text-blue-600 dark:text-blue-400 mb-6 border-b border-gray-200 dark:border-gray-700 pb-3">Dəvət Məlumatları</h3>

            <div className="space-y-6">
              {/* Dəvət Edən Şəxs */}
              <div className="text-center p-4 border border-blue-100 dark:border-blue-900/30 rounded-md bg-blue-50 dark:bg-blue-900/20">
                <h4 className="text-lg font-semibold text-blue-800 dark:text-blue-300 mb-3">Dəvət edən şəxs</h4>
                {referrerInfo?.error ? (
                  <p className="text-red-500 dark:text-red-400">{referrerInfo.error}</p>
                ) : (
                  <div className="space-y-2">
                    {referrerInfo?.referrerPhoto && (
                      <img src={referrerInfo.referrerPhoto} alt="Dəvət edən şəxsin şəkli" className="w-16 h-16 object-cover mx-auto rounded-full ring-2 ring-white dark:ring-gray-700" />
                    )}
                    <p className="text-base font-medium text-gray-700 dark:text-gray-200">{referrerInfo?.referrerName}</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">{referrerInfo?.referrerEmail}</p>
                  </div>
                )}
              </div>

              {/* Lider */}
              <div className="text-center p-4 border border-purple-100 dark:border-purple-900/30 rounded-md bg-purple-50 dark:bg-purple-900/20">
                <h4 className="text-lg font-semibold text-purple-800 dark:text-purple-300 mb-3">Lider</h4>
                {referrerInfoo?.error ? (
                  <p className="text-red-500 dark:text-red-400">{referrerInfoo.error}</p>
                ) : (
                  <div className="space-y-2">
                    {referrerInfoo?.referrerPhoto && (
                      <img src={referrerInfoo.referrerPhoto} alt="Liderin şəkli" className="w-16 h-16 object-cover mx-auto rounded-full ring-2 ring-white dark:ring-gray-700" />
                    )}
                    <p className="text-base font-medium text-gray-700 dark:text-gray-200">{referrerInfoo?.referrerName}</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">{referrerInfoo?.referrerEmail}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;